import React from "react";

const Footer = () => {
  return (
    <div id="fh5co-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <p className="mb-2">&copy; 2024 Ashu Kumar. All Rights Reserved.</p>
            <p className="mb-4">Designed and coded with <i className="icon-heart"></i> by Ashu Kumar</p>
            <ul className="fh5co-social-icons footer-social">
              <li><a href="https://linkedin.com/in/catchashu10" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a></li>
              <li><a href="https://github.com/catchashu10" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
